module.exports = __webpack_public_path__ + "img/candle.9c2444ee.svg";